import Vue from 'vue'
import axios from 'axios'

class RequestsService {
  uuidv4 () {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
      (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    )
  }

  updateRequestProperty (client, request, propertyCode, propertyValue) {
    return axios.put(`${process.env.API}${client}/requests/${request}/properties/${propertyCode}`, {
      'value': propertyValue
    })
  }

  deleteRequest (client, request) {
    return axios.delete(`${process.env.API}${client}/requests/${request}`)
  }
}

const requests = new RequestsService()

Vue.prototype.$requests = requests

export default requests
export { requests }



// WEBPACK FOOTER //
// ./src/services/request.service.js